import React from 'react';
import { ComposableModal, ModalContent, ModalFooter } from '#app/components/ModalForm';
import { Button } from 'finform';
import { Row } from '#app/pages/styles';
import Login from '../../../../pages/Auth/Login';

const LoginModal = ({ show, handleCloseModal, handleRegisterModal, i18n }) => (
  <ComposableModal
    size="extra-small"
    show={show}
    trigger=""
    title={i18n.auth?.login}
    onClose={handleCloseModal}
    closeButtonVariant="landing"
  >
    <ModalContent>
      <Login />
    </ModalContent>
    <ModalFooter>
      <Row>
        <Button
          type="cancel"
          wide
          id="register-modal-button"
          onClick={(e) => {
            e.preventDefault();
            handleRegisterModal();
          }}
        >
          {i18n.auth?.register}
        </Button>
      </Row>
    </ModalFooter>
  </ComposableModal>
);

export default LoginModal;
